import {APOLLO_OPTIONS, ApolloModule} from "apollo-angular";
import {HttpLinkModule} from "apollo-angular-link-http";
import {InMemoryCache} from "apollo-cache-inmemory";
import {ModuleWithProviders, NgModule, Optional, SkipSelf} from "@angular/core";
import {GraphqlManagerService} from "./graphql-manager.service";

export function createApollo(graphqlManagerService: GraphqlManagerService) {
  return {
    link: graphqlManagerService.apolloLink,
    cache: new InMemoryCache(),
  };
}

@NgModule({
  imports: [
    ApolloModule,
    HttpLinkModule,
  ],
  providers: [
    GraphqlManagerService,
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [GraphqlManagerService],
    },
  ],
})
export class GraphqlCoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: GraphqlCoreModule,
      providers: [
        GraphqlManagerService,
        {
          provide: APOLLO_OPTIONS,
          useFactory: createApollo,
          deps: [GraphqlManagerService],
        },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: GraphqlCoreModule) {
    if (parentModule) {
      throw new Error("GraphqlCoreModule is already loaded.  Import it in the main module only.");
    }
  }
}
